import { USERS_COLLECTION } from "../../constants/collections";
import { Config, StatusOption } from "./config";

const admin = "admin";
const director = "director";
const executor = "executor";
const operator = "operator";
const manager = "manager";
const lawyer = "lawyer";
const gym_manager = "gym_manager";
const cleaning_manager = "cleaning_manager";
const cleaning_executor = "cleaning_executor";

const ROLES = {
  ADMIN: admin,
  EXECUTOR: executor,
  MANAGER: manager,
  LAWYER: lawyer,
  OPERATOR: operator,
  GYM_MANAGER: gym_manager,
  DIRECTOR: director,
  CLEANING_MANAGER: cleaning_manager,
  CLEANING_EXECUTOR: cleaning_executor,
};

const OPEN = "open";
const BLOCKED = "blocked";
const IN_PROGRESS = "in progress";
const IN_REVIEW = "in review";
const RESOLVED = "resolved";
const LEGAL_NEW = "legal_new";
const LEGAL_IN_WORK = "legal_in_work";
const LEGAL_COMPLETED = "legal_completed";

const statuses = [OPEN, IN_PROGRESS, BLOCKED, IN_REVIEW, RESOLVED];

const ALL_ROLES = Object.values(ROLES);
const ADMIN_AND_GYM_MANAGER = [admin, gym_manager];
const LEGAL_BOARD_ROLES = [admin, manager, lawyer];
const TENANT_DIRECTORY_ROLES = [
  admin,
  director,
  manager,
  operator,
  gym_manager,
];

export const STATUS_OPTIONS: StatusOption[] = [
  {
    value: "open",
    editableBy: [
      ROLES.EXECUTOR,
      ROLES.ADMIN,
      ROLES.MANAGER,
      ROLES.CLEANING_MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: "blocked",
    editableBy: [
      ROLES.EXECUTOR,
      ROLES.ADMIN,
      ROLES.MANAGER,
      ROLES.CLEANING_MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: "in progress",
    editableBy: [
      ROLES.EXECUTOR,
      ROLES.ADMIN,
      ROLES.MANAGER,
      ROLES.CLEANING_MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: "in review",
    editableBy: [
      ROLES.ADMIN,
      ROLES.EXECUTOR,
      ROLES.MANAGER,
      ROLES.CLEANING_MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: "resolved",
    editableBy: [ROLES.MANAGER, ROLES.ADMIN, ROLES.CLEANING_MANAGER],
    visibleBy: ALL_ROLES,
  },
];

export const CLEANING_STATUS_OPTIONS: StatusOption[] = [
  {
    value: OPEN,
    editableBy: [
      ROLES.CLEANING_EXECUTOR,
      ROLES.CLEANING_MANAGER,
      ROLES.ADMIN,
      ROLES.DIRECTOR,
      ROLES.MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: IN_PROGRESS,
    editableBy: [
      ROLES.CLEANING_EXECUTOR,
      ROLES.CLEANING_MANAGER,
      ROLES.ADMIN,
      ROLES.DIRECTOR,
      ROLES.MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: IN_REVIEW,
    editableBy: [
      ROLES.CLEANING_EXECUTOR,
      ROLES.CLEANING_MANAGER,
      ROLES.ADMIN,
      ROLES.DIRECTOR,
      ROLES.MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
  {
    value: RESOLVED,
    editableBy: [
      ROLES.CLEANING_EXECUTOR,
      ROLES.CLEANING_MANAGER,
      ROLES.ADMIN,
      ROLES.DIRECTOR,
      ROLES.MANAGER,
    ],
    visibleBy: ALL_ROLES,
  },
];

export const RECURRING_STATUS_OPTIONS: StatusOption[] = [
  {
    value: OPEN,
    editableBy: ALL_ROLES,
    visibleBy: ALL_ROLES,
  },
  {
    value: RESOLVED,
    editableBy: ALL_ROLES,
    visibleBy: ALL_ROLES,
  },
];

export const LEGAL_STATUS_OPTIONS: StatusOption[] = [
  {
    value: LEGAL_NEW,
    editableBy: [lawyer],
    visibleBy: ALL_ROLES,
  },
  {
    value: LEGAL_IN_WORK,
    editableBy: [lawyer],
    visibleBy: ALL_ROLES,
  },
  {
    value: LEGAL_COMPLETED,
    editableBy: [lawyer],
    visibleBy: ALL_ROLES,
  },
];

const DEPARTMENTS = {
  // CLEANING: "cleaning",
  TECHNICAL: "technical",
  CLEANING: "cleaning",
};

const BLOCKS = {
  NO: "блоксыз",
  MANHATTAN: "Manhattan",
  TOKYO: "Tokyo",
  DUBAI: "Dubai",
  GENEVA: "Geneva",
  BOSTON: "Boston",
  True_Active: "True & Active",
};

const BLOCK_COLOR_RULES = [
  { text: BLOCKS.NO, color: "#111827" },
  { text: BLOCKS.MANHATTAN, color: "#1E3A8A" },
  { text: BLOCKS.TOKYO, color: "#5B21B6" },
  { text: BLOCKS.DUBAI, color: "#92400E" },
  { text: BLOCKS.GENEVA, color: "#065F46" },
  { text: BLOCKS.BOSTON, color: "#9D174D" },
  { text: BLOCKS.True_Active, color: "#166534" },
];

const TASK_STATUS_COLORS: Record<string, string> = {
  [OPEN]: "#9333ea",
  [BLOCKED]: "#1d4ed8",
  [IN_PROGRESS]: "#16a34a",
  [IN_REVIEW]: "#f59e0b",
  [RESOLVED]: "#dc2626",
};

const LEGAL_STATUS_COLORS: Record<string, string> = {
  [LEGAL_NEW]: "#9333ea",
  [LEGAL_IN_WORK]: "#16a34a",
  [LEGAL_COMPLETED]: "#dc2626",
};

const BOARD_FIELD_ICONS = {
  category: { source: "cube-outline", color: "#a855f7" },
  executor: { source: "account-outline", color: "#ec4899" },
  block: { source: "map-marker-outline", color: "#38bdf8" },
} as const;

export const cleaningCategories = {
  VACUUMING: "Пылесостау",
  NAPKIN_REFILL: "Салфетка толтыру",
  PAPER_REFILL: "Бумага толтыру",
  HAND_CREAM: "Крем для рук",
  SOAP_REFILL: "Жидкое мыло толтыру",
  CLOTHES_ROLLER: "Ролик для одежды",
  SHOE_SPONGE: "Губка для обуви",
  DUST_WIPING: "Шаң сүрту",
  ELEVATOR_BUTTONS: "Лифт кнопкаларын сүрту",
  AIR_FRESHENER: "Освежитель қою",
  TOILET_BRUSH: "Ершик",
};

export const cleaningRoles = {
  CLEANING_MANAGER: "cleaning_manager",
  CLEANING_EXECUTOR: "cleaning_executor",
};

export const allCategories = {
  CONDITIONING_HEATING: "кондиционер/отопление",
  LIGHTING: "освещение",
  DOOR_LOCK_WALLS_HANDLES: "дверь/замок/стены/ручки",
  BATHROOMS: "санузлы",
  BARRIER: "шлагбаум",
  ROLLER_BLINDS: "ролл шторы",
  ELEVATOR: "лифт",
  PAINT: "покраска",
  OTHER: "другое",
};

const TASK_TYPES = {
  DAILY: "daily",
  WEEKLY: "weekly",
  MONTHLY: "monthly",
  ANNUAL: "annual",
  ONE_TIME: "one time",
};

const SUBSCRIPTIONS = ["СВБ", "Дневной", "Безлимит"];

const config: Config = {
  appName: "DownTown",
  mainCollection: "hotel-tasks",
  theme: {
    primaryColor: "#3498db",
    secondaryColor: "#2ecc71",
  },
  roles: ALL_ROLES,
  defaultRole: cleaning_executor,
  statuses: statuses,
  employeesVisibleTo: [admin, director],
  employeesEditableBy: [admin, director],
  initialScreen: "BoardScreen",
  initialScreenByRole: {
    [cleaning_executor]: "CleaningBoardScreen",
    [cleaning_manager]: "CleaningBoardScreen",
    [lawyer]: "LawyerBoardScreen",
    [gym_manager]: "Subscriptions",
  },
  screens: [
    {
      name: "BoardScreen",
      type: "board",
      collection: "hotel-tasks",
      roles: [
        admin,
        operator,
        executor,
        manager,
        cleaning_executor,
        cleaning_manager,
        director,
        gym_manager,
      ],
      showAdd: [
        admin,
        operator,
        director,
        gym_manager,
        executor,
        cleaning_executor,
        manager,
        cleaning_manager,
      ],
      statusOptions: STATUS_OPTIONS,
      defaultPresentation: "horizontal",
      statusColors: TASK_STATUS_COLORS,
      where: [
        {
          field: "archived",
          operator: "==",
          value: false,
        },
        {
          field: "department",
          operator: "==",
          value: DEPARTMENTS.TECHNICAL,
          applyToRoles: [gym_manager, cleaning_manager, cleaning_executor],
        },
      ],
      showBoardTypeSelector: false,
    },
    {
      name: "CleaningBoardScreen",
      type: "board",
      collection: "cleaning-tasks",
      roles: [
        admin,
        director,
        cleaning_manager,
        cleaning_executor,
        manager,
        operator,
      ],
      showAdd: [admin, operator, director, cleaning_manager, manager],
      statusOptions: CLEANING_STATUS_OPTIONS,
      defaultPresentation: "horizontal",
      statusColors: TASK_STATUS_COLORS,
      where: [
        {
          field: "archived",
          operator: "==",
          value: false,
        },
        {
          field: "block",
          operator: "==",
          value: "block",
          from: "user",
          applyToRoles: [cleaning_executor, operator],
        },
      ],
      showBoardTypeSelector: false,
    },
    {
      name: "LawyerBoardScreen",
      type: "board",
      collection: "legal-tasks",
      roles: [admin, operator, lawyer, director],
      showAdd: [admin, operator, lawyer],
      statusOptions: LEGAL_STATUS_OPTIONS,
      defaultPresentation: "horizontal",
      statusColors: LEGAL_STATUS_COLORS,
      where: [
        {
          field: "archived",
          operator: "==",
          value: false,
        },
        {
          field: "createdById",
          operator: "==",
          value: "uid",
          from: "user",
          applyToRoles: [
            executor,
            operator,
            gym_manager,
            cleaning_manager,
            cleaning_executor,
          ],
        },
      ],
      showBoardTypeSelector: false,
    },
    {
      name: "HotelReportsScreen",
      type: "reports",
      collection: "hotel-tasks",
      roles: [admin, director],
    },
    {
      name: "RecurringTasksScreen",
      type: "board",
      collection: "recurring-tasks",
      icon: "refresh",
      roles: [admin, operator, executor, manager, director, gym_manager],
      showAdd: [],
      statusOptions: RECURRING_STATUS_OPTIONS,
      defaultPresentation: "horizontal",
      statusColors: TASK_STATUS_COLORS,
      where: [
        {
          field: "archived",
          operator: "==",
          value: false,
        },
      ],
      showBoardTypeSelector: false,
    },
    {
      name: "RecurringTaskTemplatesScreen",
      type: "list",
      collection: "recurring-hotel-tasks",
      icon: "file-document-outline",
      roles: [admin, manager, director, gym_manager],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      loadAll: true,
      showAdd: [admin, manager, director, gym_manager],
      filters: [
        {
          field: "description",
          type: "search",
          label: "Поиск",
          searchTermKeys: ["description", "category", "block"],
        },
      ],
      orderBy: [
        { field: "type", direction: "asc" },
        { field: "createdAt", direction: "desc" },
      ],
    },
    {
      name: "ArchivedHotelTasksScreen",
      type: "list",
      collection: "hotel-tasks,cleaning-tasks",
      icon: "archive-outline",
      roles: [
        admin,
        operator,
        executor,
        manager,
        director,
        gym_manager,
        cleaning_executor,
        cleaning_manager,
      ],
      showAdd: [],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      where: [
        {
          field: "archived",
          operator: "==",
          value: true,
        },
      ],
      loadAll: true,
      csvExport: {
        enabled: true,
        fileName: "archived-hotel-tasks",
      },
      filters: [
        {
          field: "createdAt",
          type: "date",
          label: "Period",
        },
        {
          field: "_collection",
          type: "dropdown",
          label: "Task Type",
          options: ["hotel-tasks", "cleaning-tasks"],
        },
        {
          field: "tenantCompany",
          type: "dropdown",
          label: "Tenant company",
          optionsFromCollection: "hotel_tenant_companies",
          optionsCollectionKey: "name",
          dependsOn: {
            field: "block",
          },
        },
        {
          field: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
        },
      ],
      orderBy: [{ field: "createdAt", direction: "desc" }],
    },
    {
      name: "Subscriptions",
      type: "list",
      collection: "gym-subscriptions",
      icon: "account-outline",
      roles: [admin, director, gym_manager],
      lazy: false,
      presentation: "table",
    },
    {
      name: "WarehouseScreen",
      type: "list",
      collection: "warehouses",
      icon: "warehouse",
      roles: [director, admin, manager, executor],
      showAdd: [admin, director, manager],
      onlyCompany: false,
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      filters: [
        {
          field: "name",
          type: "search",
          label: "Поиск",
          searchTermKeys: ["name"],
        },
      ],
    },
    {
      name: "TechWarehouseScreen",
      type: "list",
      collection: "tech_warehouse",
      icon: "warehouse",
      roles: [director, admin, manager, executor],
      showAdd: [admin, director, manager],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      orderBy: [
        { field: "productName", direction: "asc" },
        { field: "location", direction: "asc" },
        { field: "quantity", direction: "desc" },
      ],
      filters: [
        {
          field: "productName",
          type: "search",
          label: "Поиск",
          searchTermKeys: ["productName", "location", "description"],
        },
      ],
    },
    {
      name: "TechWarehouseReceiptsScreen",
      type: "list",
      collection: "tech_warehouse_receipts",
      icon: "package-variant",
      roles: [admin, manager, director],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      orderBy: [
        { field: "receivedBy.fullName", direction: "asc" },
        { field: "date", direction: "desc" },
      ],
      filters: [
        {
          field: "receivedBy.fullName",
          type: "search",
          label: "Поиск",
          searchTermKeys: ["receivedBy.fullName", "notes", "items"],
        },
        {
          field: "date",
          type: "date",
          label: "По дате",
        },
      ],
    },
    {
      name: "CleaningWarehouseScreen",
      type: "list",
      collection: "clean_warehouse",
      icon: "warehouse",
      roles: [director, admin, cleaning_executor, cleaning_manager],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      orderBy: [
        { field: "productName", direction: "asc" },
        { field: "location", direction: "asc" },
        { field: "quantity", direction: "desc" },
      ],
      showAdd: [admin, director, cleaning_manager],
      filters: [
        {
          field: "productName",
          type: "search",
          label: "Поиск",
          searchTermKeys: ["productName", "location", "description"],
        },
      ],
    },
    {
      name: "HotelTenantCompaniesScreen",
      type: "list",
      collection: "hotel_tenant_companies",
      icon: "office-building-outline",
      roles: [admin, manager, cleaning_manager],
      showAdd: [admin],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      loadAll: true,
      orderBy: [{ field: "name", direction: "asc" }],
      filters: [
        {
          field: "name",
          type: "search",
          label: "Company name",
          searchTermKeys: ["name", "block"],
        },
        {
          field: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
        },
      ],
    },
    {
      name: "HotelTenantEmployeesScreen",
      type: "list",
      collection: "hotel_tenant_company_employees",
      icon: "badge-account-horizontal-outline",
      roles: [admin, director, operator],
      showAdd: [admin, director, operator],
      lazy: false,
      presentation: "table",
      tableResponsive: {
        enabled: true,
      },
      loadAll: true,
      orderBy: [{ field: "fullName", direction: "asc" }],
      filters: [
        {
          field: "fullName",
          type: "search",
          label: "Поиск",
          searchTermKeys: [
            "fullName",
            "tenantCompany.name",
            "position",
            "note",
          ],
        },
      ],
    },
    {
      name: "DriveScreen",
      type: "drive",
      collection: "drive_files",
      icon: "folder-outline",
      roles: [admin, director],
    },
  ],
  database: [
    {
      name: "warehouses",
      deletableBy: [admin, director, manager],
      fields: [
        {
          name: "name",
          type: "text",
          label: "Name",
          required: true,
          list: ALL_ROLES,
          formCreate: [admin, director, manager],
          formEdit: [admin, director, manager],
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Date created",
          list: [],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: "hotel-tasks",
      deletableBy: [admin, manager, gym_manager, director, executor],
      visibleAt: true,
      activityLogs: {
        roles: [admin],
        subcollection: "logs",
        limit: 20,
      },
      fields: [
        {
          name: "description",
          type: "textarea",
          label: "Task description",
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [
            executor,
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_executor,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardValueBold: true,
        },
        {
          name: "category",
          type: "dropdown",
          label: "Type",
          options: Object.values(allCategories),
          disableSearch: false,
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [
            executor,
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_executor,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardDisplayIcon: BOARD_FIELD_ICONS.category,
          // allowCustomInput: true,
        },
        {
          name: "executor",
          type: "collectionPicker",
          label: "Executor",
          collection: USERS_COLLECTION,
          hideLabel: true,
          key: "fullName",
          where: [{ field: "role", operator: "==", value: executor }],
          list: ALL_ROLES,
          form: [executor, manager, director],
          board: ALL_ROLES,
          boardDisplayIcon: BOARD_FIELD_ICONS.executor,
          recurringTaskBehavior: {
            action: "reset",
            resetValue: "",
          },
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          disableSearch: true,
          hideLabel: true,
          list: [],
          formCreate: [
            admin,
            manager,
            operator,
            gym_manager,
            director,
            executor,
            gym_manager,
            cleaning_executor,
            cleaning_manager,
          ],
          formEdit: [
            admin,
            manager,
            operator,
            gym_manager,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          useUserValue: true,
          autoSelectFrom: "description",
          boardDisplayIcon: BOARD_FIELD_ICONS.block,
        },
        {
          name: "tenantCompany",
          type: "collectionPicker",
          label: "Tenant company",
          collection: "hotel_tenant_companies",
          key: "name",
          secondKey: "block",
          where: [
            {
              field: "block",
              operator: "==",
              from: "formData",
              value: "block",
            },
          ],
          visibleWhen: {
            field: "block",
            notEmpty: true,
          },
          list: [],
          formCreate: [
            admin,
            manager,
            operator,
            gym_manager,
            director,
            gym_manager,
            cleaning_executor,
          ],
          formEdit: [
            admin,
            manager,
            operator,
            gym_manager,
            director,
            gym_manager,
          ],
          board: [],
        },
        {
          name: "department",
          type: "segmentedButtons",
          label: "Department",
          hideLabel: true,
          options: Object.values(DEPARTMENTS),
          disableSearch: true,
          defaultValue: DEPARTMENTS.TECHNICAL,
          list: [],
          formCreate: [],
          formEdit: [],
          board: [],
        },
        {
          name: "status",
          type: "status",
          label: "Status",
          statusOptions: STATUS_OPTIONS,
          defaultValue: OPEN,
          list: [],
          formEdit: [
            executor,
            manager,
            admin,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formCreate: [],
          board: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: OPEN,
          },
        },
        {
          name: "note",
          type: "textarea",
          label: "Note",
          list: [],
          formCreate: [executor, manager, cleaning_manager],
          formEdit: [executor, manager, cleaning_manager, cleaning_executor],
          board: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: "",
          },
        },
        {
          name: "srok",
          type: "datePicker",
          label: "Deadline",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "checklist",
          type: "checklist",
          label: "Checklist",
          hideLabel: true,
          list: [],
          // cleaning_executor должен видеть в тех заявках только вложения и заметку
          form: [
            admin,
            manager,
            operator,
            director,
            gym_manager,
            executor,
            cleaning_manager,
          ],
          board: ALL_ROLES,
        },
        {
          name: "attachments",
          type: "file",
          label: "Attachments",
          list: [],
          form: ALL_ROLES,
          board: ALL_ROLES,
        },
        {
          name: "createdAt",
          type: "datePicker",
          hideLabel: true,
          label: "Date Created",
          list: ALL_ROLES,
          form: [],
          board: ALL_ROLES,
        },
        {
          name: "visibleAt",
          type: "datePicker",
          hideLabel: true,
          label: "Visible For Others At",
          list: [],
          formCreate: [
            executor,
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_executor,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: [],
        },
        {
          name: "st_in progress_at",
          type: "dateTimeNoYear",
          label: "in progress",
          list: [],
          form: [],
          board: [],
          recurringTaskBehavior: {
            action: "remove",
          },
        },
        {
          name: "st_in review_at",
          type: "dateTimeNoYear",
          label: "in review",
          list: [],
          form: [],
          board: [],
          recurringTaskBehavior: {
            action: "remove",
          },
        },
        {
          name: "archived",
          type: "booleanCheckbox",
          label: "Archived",
          defaultValue: false,
          list: [],
          form: [],
          board: [],
          details: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: false,
          },
        },
        {
          name: "warehouseItems",
          type: "warehouseItemsPicker",
          label: "Заттар",
          collection: "tech_warehouse",
          key: "productName",
          secondKey: "quantity",
          list: ALL_ROLES,
          formCreate: [
            executor,
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            executor,
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
        },
        {
          name: "chat",
          type: "chat",
          label: "Open Chat",
          hideLabel: true,
          list: [],
          form: ALL_ROLES,
          formCreate: [],
          formEdit: [],
          details: ALL_ROLES,
          board: [],
        },
      ],
    },
    {
      name: "cleaning-tasks",
      deletableBy: [
        admin,
        manager,
        gym_manager,
        director,
        cleaning_manager,
        operator,
      ],
      visibleAt: true,
      fields: [
        {
          name: "description",
          type: "text",
          label: "Task description",
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [
            manager,
            admin,
            operator,
            director,
            cleaning_manager,
            gym_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            cleaning_manager,
            gym_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardValueBold: true,
        },
        {
          name: "category",
          type: "dropdown",
          label: "Type",
          options: Object.values(cleaningCategories),
          disableSearch: false,
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [
            manager,
            admin,
            operator,
            director,
            cleaning_manager,
            gym_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            cleaning_manager,
            gym_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardDisplayIcon: BOARD_FIELD_ICONS.category,
          // allowCustomInput: true,
        },
        {
          name: "executor",
          type: "collectionPicker",
          label: "Executor",
          collection: USERS_COLLECTION,
          hideLabel: true,
          key: "fullName",
          where: [{ field: "role", operator: "==", value: cleaning_executor }],
          list: ALL_ROLES,
          form: [manager, director, cleaning_manager],
          board: ALL_ROLES,
          boardDisplayIcon: BOARD_FIELD_ICONS.executor,
          recurringTaskBehavior: {
            action: "reset",
            resetValue: "",
          },
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          disableSearch: true,
          hideLabel: true,
          list: [],
          formCreate: [admin, gym_manager, director, cleaning_manager],
          formEdit: [admin, gym_manager, director, cleaning_manager],
          board: ALL_ROLES,
          useUserValue: true,
          autoSelectFrom: "description",
          boardDisplayIcon: BOARD_FIELD_ICONS.block,
        },
        {
          name: "tenantCompany",
          type: "collectionPicker",
          label: "Tenant company",
          collection: "hotel_tenant_companies",
          key: "name",
          secondKey: "block",
          where: [
            {
              field: "block",
              operator: "==",
              from: "formData",
              value: "block",
            },
          ],
          visibleWhen: {
            field: "block",
            notEmpty: true,
          },
          list: [],
          formCreate: [admin, gym_manager, director, cleaning_manager],
          formEdit: [admin, gym_manager, director, cleaning_manager],
          board: [],
        },
        {
          name: "status",
          type: "status",
          label: "Status",
          statusOptions: CLEANING_STATUS_OPTIONS,
          defaultValue: OPEN,
          list: ALL_ROLES,
          formEdit: [
            executor,
            manager,
            admin,
            gym_manager,
            director,
            cleaning_executor,
            cleaning_manager,
          ],
          formCreate: [],
          board: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: OPEN,
          },
        },
        {
          name: "note",
          type: "textarea",
          label: "Note",
          list: [],
          formCreate: [],
          formEdit: [executor, cleaning_executor, manager],
          board: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: "",
          },
        },
        {
          name: "deadline",
          type: "datePicker",
          label: "Deadline",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "checklist",
          type: "checklist",
          hideLabel: true,
          label: "Checklist",
          list: [],
          // cleaning_executor должен редактировать только: status + note + attachments
          form: [
            admin,
            manager,
            operator,
            director,
            gym_manager,
            executor,
            cleaning_manager,
          ],
          board: ALL_ROLES,
        },
        {
          name: "attachments",
          type: "file",
          label: "Attachments",
          list: [],
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Date Created",
          list: [],
          form: [],
          board: ALL_ROLES,
        },
        {
          name: "visibleAt",
          type: "datePicker",
          hideLabel: true,
          label: "Visible For Others At",
          list: [],
          formCreate: [manager, admin, operator, director, cleaning_manager],
          formEdit: [manager, admin, operator, director, cleaning_manager],
          board: [],
        },
        {
          name: "archived",
          type: "booleanCheckbox",
          label: "Archived",
          defaultValue: false,
          list: [],
          form: [],
          board: [],
          details: [],
          recurringTaskBehavior: {
            action: "reset",
            resetValue: false,
          },
        },
      ],
    },
    {
      name: "legal-tasks",
      deletableBy: [admin, manager],
      visibleAt: true,
      fields: [
        {
          name: "createdAt",
          type: "datePicker",
          label: "Submission Date",
          list: [],
          form: [],
          board: ALL_ROLES,
          valueDisplayMode: "stacked",
        },
        {
          name: "initiatorFullName",
          type: "text",
          label: "Initiator Full Name",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: ALL_ROLES,
          autoFocus: true,
          valueDisplayMode: "stacked",
        },
        {
          name: "contractName",
          type: "text",
          label: "Contract Name",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: ALL_ROLES,
          valueDisplayMode: "stacked",
        },
        {
          name: "contractSubject",
          type: "dropdown",
          label: "Type of Goods/Works/Services",
          options: ["legal_goods", "legal_works", "legal_services"],
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "executionTerms",
          type: "text",
          label: "Delivery / Execution Terms",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "contractAmount",
          type: "text",
          label: "Contract Amount",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: ALL_ROLES,
          valueDisplayMode: "stacked",
        },
        {
          name: "vatType",
          type: "dropdown",
          label: "VAT Type",
          options: ["legal_with_vat", "legal_without_vat"],
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: ALL_ROLES,
          valueDisplayMode: "stacked",
        },
        {
          name: "paymentProcedure",
          type: "dropdown",
          label: "Payment Procedure",
          options: ["legal_prepayment", "legal_postpayment"],
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "contractorName",
          type: "text",
          label: "Contractor Name",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "contractorContacts",
          type: "text",
          label: "Contractor Contacts",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "commercialProposal",
          type: "text",
          label: "Commercial Proposal",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "comments",
          type: "textarea",
          label: "Comments",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
          valueDisplayMode: "stacked",
        },
        {
          name: "attachments",
          type: "fileAndDocument",
          label: "Attachments",
          list: [],
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: ALL_ROLES,
          valueDisplayMode: "stacked",
        },
        {
          name: "status",
          type: "status",
          label: "Status",
          statusOptions: LEGAL_STATUS_OPTIONS,
          defaultValue: LEGAL_NEW,
          list: [],
          formCreate: [],
          formEdit: [lawyer],
          board: [],
          details: [],
        },
        {
          name: "archived",
          type: "booleanCheckbox",
          label: "Archived",
          defaultValue: false,
          list: [],
          form: [],
          board: [],
          details: [],
        },
      ],
    },
    {
      name: USERS_COLLECTION,
      fields: [
        {
          name: "role",
          type: "dropdown",
          label: "Role",
          options: ALL_ROLES,
          list: [admin, gym_manager, director],
          form: [admin, director],
          board: [admin, director],
        },
        {
          name: "email",
          type: "text",
          label: "Email",
          readOnly: true,
          list: [admin, gym_manager, director],
          form: [admin, gym_manager, director],
          board: [admin, gym_manager, director],
        },
        {
          name: "avatarUrl",
          type: "url",
          label: "Avatar",
          readOnly: true,
          list: [],
          form: [],
          board: [],
        },
        {
          name: "fullName",
          type: "text",
          label: "Full name",
          readOnly: true,
          list: [admin, gym_manager, director],
          form: [admin, gym_manager, director],
          board: [admin, gym_manager, director],
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          form: [admin, director],
          list: [admin, gym_manager, director],
          required: true,
          variant: "titleMedium",
        },
      ],
    },
    {
      name: "hotel_tenant_companies",
      deletableBy: TENANT_DIRECTORY_ROLES,
      fields: [
        {
          name: "name",
          type: "text",
          label: "Company name",
          required: true,
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          required: true,
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
      ],
    },
    {
      name: "hotel_tenant_company_employees",
      deletableBy: TENANT_DIRECTORY_ROLES,
      fields: [
        {
          name: "fullName",
          type: "text",
          label: "Full name",
          required: true,
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "tenantCompany",
          type: "collectionPicker",
          label: "Tenant company",
          collection: "hotel_tenant_companies",
          key: "name",
          onlyId: true,
          showAdd: TENANT_DIRECTORY_ROLES,
          required: true,
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "position",
          type: "text",
          label: "Position",
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "birthDate",
          type: "datePicker",
          label: "Birthday",
          required: true,
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "note",
          type: "textarea",
          label: "Note",
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
        },
        {
          name: "attachments",
          type: "file",
          label: "Attachments",
          list: TENANT_DIRECTORY_ROLES,
          form: TENANT_DIRECTORY_ROLES,
          board: [],
          width: 0.6,
        },
      ],
    },
    {
      name: "gym-subscriptions",
      deletableBy: ADMIN_AND_GYM_MANAGER,
      fields: [
        {
          name: "name",
          type: "text",
          label: "Имя",
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "payment",
          type: "number",
          label: "Оплата",
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "date",
          type: "datePicker",
          label: "Дата",
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "subscription",
          type: "dropdown",
          label: "Абонемент",
          options: SUBSCRIPTIONS,
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "validUntil",
          type: "datePicker",
          label: "Действует До",
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
          rowStyleCondition: {
            operator: "past",
            style: {
              backgroundColor: "#ffebee",
              color: "#c62828",
            },
          },
        },
        {
          name: "remind",
          type: "textarea",
          label: "Связь (напоминание)",
          required: false,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
        {
          name: "phoneNumber",
          type: "text",
          label: "Номер телефона",
          required: true,
          list: ALL_ROLES,
          form: ALL_ROLES,
          board: [],
        },
      ],
    },
    {
      name: "tech_warehouse",
      deletableBy: [admin, manager, director, gym_manager],
      fields: [
        {
          name: "productName",
          type: "text",
          label: "Наименование товара",
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager],
          formEdit: [admin, manager, director, gym_manager, executor],
          readOnly: false,
          board: [],
        },
        {
          name: "quantity",
          type: "number",
          label: "Количество",
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager],
          formEdit: [admin, manager, director, gym_manager, executor],
          board: [],
        },
        {
          name: "reservedQuantity",
          type: "number",
          label: "Зарезервировано",
          required: true,
          defaultValue: 0,
          list: ALL_ROLES,
          form: [], // read-only, managed by Firebase Functions
          board: [],
        },
        {
          name: "description",
          type: "textarea",
          label: "Описание",
          required: false,
          list: [],
          form: [admin, manager, director, gym_manager],
          board: [],
        },
        {
          name: "location",
          type: "collectionPicker",
          label: "Расположение",
          collection: "warehouses",
          key: "name",
          onlyCompany: false,
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager],
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Дата создания",
          list: [],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: "clean_warehouse",
      deletableBy: [admin, manager, director, gym_manager, cleaning_manager],
      fields: [
        {
          name: "productName",
          type: "text",
          label: "Наименование товара",
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager, cleaning_manager],
          board: [],
        },
        {
          name: "quantity",
          type: "number",
          label: "Количество",
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager, cleaning_manager],
          formEdit: [
            admin,
            manager,
            director,
            gym_manager,
            cleaning_executor,
            cleaning_manager,
          ],
          board: [],
        },
        {
          name: "description",
          type: "textarea",
          label: "Описание",
          required: false,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager, cleaning_manager],
          board: [],
        },
        {
          name: "location",
          type: "collectionPicker",
          label: "Расположение",
          collection: "warehouses",
          key: "name",
          onlyCompany: false,
          required: true,
          list: ALL_ROLES,
          form: [admin, manager, director, gym_manager, cleaning_manager],
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Дата создания",
          list: [],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: "tech_warehouse_receipts",
      deletableBy: [admin, director, manager],
      fields: [
        {
          name: "date",
          type: "datePicker",
          label: "Келу күні",
          required: true,
          list: [admin, manager, director],
          formCreate: [admin, manager, director],
          formEdit: [admin, director, manager],
          board: [],
        },
        {
          name: "location",
          type: "collectionPicker",
          label: "Расположение",
          collection: "warehouses",
          key: "name",
          onlyCompany: false,
          required: true,
          list: [admin, manager, director],
          formCreate: [admin, manager, director],
          formEdit: [admin, director, manager],
          board: [],
        },
        {
          name: "items",
          type: "warehouseItemsPicker",
          label: "Заттар",
          collection: "tech_warehouse",
          key: "productName",
          secondKey: "quantity",
          required: true,
          list: [admin, manager, director],
          formCreate: [admin, manager, director],
          formEdit: [admin, director, manager],
          board: [admin, manager, director],
        },
        {
          name: "receivedBy",
          type: "collectionPicker",
          label: "Қабылдаған",
          collection: USERS_COLLECTION,
          key: "fullName",
          list: [admin, manager, director],
          formCreate: [admin, manager, director],
          formEdit: [admin, director, manager],
          board: [admin, manager, director],
          useUserValue: true,
        },
        {
          name: "notes",
          type: "textarea",
          label: "Ескертпе",
          required: false,
          list: [admin, manager, director],
          formCreate: [admin, manager, director],
          formEdit: [admin, director, manager],
          board: [],
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Жасалған күні",
          list: [],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: "files",
      deletableBy: [admin, manager, director, gym_manager],
      fields: [
        {
          name: "name",
          type: "text",
          label: "File name",
          required: true,
          list: ALL_ROLES,
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
        },
        {
          name: "fileUrl",
          type: "document",
          label: "File",
          required: true,
          list: ALL_ROLES,
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
        },
        {
          name: "description",
          type: "textarea",
          label: "Description",
          required: false,
          list: ALL_ROLES,
          formCreate: ALL_ROLES,
          formEdit: ALL_ROLES,
          board: [],
        },
        {
          name: "createdBy",
          type: "collectionPicker",
          label: "Added by",
          collection: USERS_COLLECTION,
          key: "fullName",
          list: ALL_ROLES,
          formCreate: [],
          formEdit: [],
          board: [],
          useUserValue: true,
        },
        {
          name: "dateAdded",
          type: "dateTime",
          label: "Date added",
          list: ALL_ROLES,
          form: [],
          board: [],
          hideLabel: true,
        },
        {
          name: "createdAt",
          type: "dateTime",
          hideLabel: true,
          label: "Created at",
          list: [],
          form: [],
          board: [],
        },
      ],
    },
    {
      name: "recurring-tasks",
      deletableBy: [admin, manager, gym_manager, director],
      visibleAt: true,
      fields: [
        {
          name: "description",
          type: "textarea",
          label: "Task description",
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [manager, admin, operator, director, gym_manager],
          formEdit: [manager, admin, operator, director, gym_manager],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardValueBold: true,
        },
        {
          name: "category",
          type: "dropdown",
          label: "Type",
          options: Object.values(allCategories),
          disableSearch: false,
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [manager, admin, operator, director, gym_manager],
          formEdit: [manager, admin, operator, director, gym_manager],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardDisplayIcon: BOARD_FIELD_ICONS.category,
        },
        {
          name: "executor",
          type: "collectionPicker",
          label: "Executor",
          collection: USERS_COLLECTION,
          hideLabel: true,
          key: "fullName",
          where: [{ field: "role", operator: "==", value: executor }],
          list: ALL_ROLES,
          form: [manager, director],
          board: ALL_ROLES,
          boardDisplayIcon: BOARD_FIELD_ICONS.executor,
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          disableSearch: true,
          hideLabel: true,
          list: [],
          formCreate: [admin, gym_manager, director, gym_manager],
          formEdit: [admin, gym_manager, director, gym_manager],
          board: ALL_ROLES,
          useUserValue: true,
          autoSelectFrom: "description",
          boardDisplayIcon: BOARD_FIELD_ICONS.block,
        },
        {
          name: "department",
          type: "segmentedButtons",
          label: "Department",
          hideLabel: true,
          options: Object.values(DEPARTMENTS),
          disableSearch: true,
          defaultValue: DEPARTMENTS.TECHNICAL,
          list: [],
          formCreate: [],
          formEdit: [],
          board: [],
        },
        {
          name: "status",
          type: "status",
          label: "Status",
          statusOptions: RECURRING_STATUS_OPTIONS,
          defaultValue: OPEN,
          list: [],
          formEdit: ALL_ROLES,
          formCreate: [],
          board: [],
        },
        {
          name: "note",
          type: "textarea",
          label: "Note",
          list: [],
          formCreate: [],
          formEdit: [executor, manager],
          board: [],
        },
        {
          name: "srok",
          type: "datePicker",
          label: "Deadline",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "checklist",
          type: "checklist",
          label: "Checklist",
          hideLabel: true,
          list: [],
          form: ALL_ROLES,
          board: ALL_ROLES,
        },
        {
          name: "attachments",
          type: "file",
          label: "Attachments",
          list: [],
          form: ALL_ROLES,
          board: ALL_ROLES,
        },
        {
          name: "createdAt",
          type: "datePicker",
          hideLabel: true,
          label: "Date Created",
          list: ALL_ROLES,
          form: [],
          board: ALL_ROLES,
        },
        {
          name: "st_in progress_at",
          type: "dateTimeNoYear",
          label: "in progress",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "st_in review_at",
          type: "dateTimeNoYear",
          label: "in review",
          list: [],
          form: [],
          board: [],
        },
        {
          name: "archived",
          type: "booleanCheckbox",
          label: "Archived",
          defaultValue: false,
          list: [],
          form: [],
          board: [],
          details: [],
        },
        {
          name: "warehouseItems",
          type: "warehouseItemsPicker",
          label: "Заттар",
          collection: "tech_warehouse",
          key: "productName",
          secondKey: "quantity",
          list: ALL_ROLES,
          formCreate: [manager, admin, operator, director, gym_manager],
          formEdit: [executor, manager, admin, operator, director, gym_manager],
          board: ALL_ROLES,
        },
        {
          name: "chat",
          type: "chat",
          label: "Open Chat",
          hideLabel: true,
          list: [],
          form: ALL_ROLES,
          formCreate: [],
          formEdit: [],
          details: ALL_ROLES,
          board: [],
        },
        {
          name: "recurringType",
          type: "dropdown",
          label: "Frequency",
          hideLabel: true,
          sortRankMap: {
            [TASK_TYPES.DAILY]: 1,
            [TASK_TYPES.WEEKLY]: 2,
            [TASK_TYPES.MONTHLY]: 3,
            [TASK_TYPES.ANNUAL]: 4,
          },
          options: [
            TASK_TYPES.DAILY,
            TASK_TYPES.WEEKLY,
            TASK_TYPES.MONTHLY,
            TASK_TYPES.ANNUAL,
          ],
          disableSearch: true,
          defaultValue: TASK_TYPES.WEEKLY,
          list: ALL_ROLES,
          formCreate: [],
          formEdit: [],
          board: ALL_ROLES,
          required: true,
        },
      ],
    },
    {
      name: "recurring-hotel-tasks",
      deletableBy: [admin, manager, gym_manager, director, cleaning_manager],
      fields: [
        {
          name: "description",
          type: "textarea",
          label: "Task description",
          hideLabel: true,
          list: ALL_ROLES,
          formCreate: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardValueBold: true,
        },
        {
          name: "category",
          type: "dropdown",
          label: "Type",
          options: [
            ...Object.values(allCategories),
            ...Object.values(cleaningCategories),
          ],
          disableSearch: false,
          hideLabel: true,
          list: [],
          formCreate: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          required: true,
          autoFocus: true,
          boardDisplayIcon: BOARD_FIELD_ICONS.category,
        },
        {
          name: "block",
          type: "dropdown",
          label: "Block",
          options: Object.values(BLOCKS),
          boardValueColorRules: BLOCK_COLOR_RULES,
          disableSearch: true,
          hideLabel: true,
          list: [],
          formCreate: [admin, gym_manager, director, cleaning_manager],
          formEdit: [admin, gym_manager, director, cleaning_manager],
          board: ALL_ROLES,
          useUserValue: true,
          autoSelectFrom: "description",
          boardDisplayIcon: BOARD_FIELD_ICONS.block,
        },
        {
          name: "department",
          type: "segmentedButtons",
          label: "Department",
          hideLabel: true,
          options: Object.values(DEPARTMENTS),
          disableSearch: true,
          defaultValue: DEPARTMENTS.TECHNICAL,
          list: [],
          formCreate: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
        },
        {
          name: "checklist",
          type: "checklist",
          label: "Checklist",
          list: [],
          formCreate: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
        },
        {
          name: "type",
          type: "dropdown",
          label: "Frequency",
          hideLabel: true,
          sortRankMap: {
            [TASK_TYPES.DAILY]: 1,
            [TASK_TYPES.WEEKLY]: 2,
            [TASK_TYPES.MONTHLY]: 3,
            [TASK_TYPES.ANNUAL]: 4,
          },
          options: [
            TASK_TYPES.DAILY,
            TASK_TYPES.WEEKLY,
            TASK_TYPES.MONTHLY,
            TASK_TYPES.ANNUAL,
          ],
          disableSearch: true,
          defaultValue: TASK_TYPES.WEEKLY,
          list: ALL_ROLES,
          formCreate: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          formEdit: [
            manager,
            admin,
            operator,
            director,
            gym_manager,
            cleaning_manager,
          ],
          board: ALL_ROLES,
          required: true,
        },
        {
          name: "createdAt",
          type: "datePicker",
          hideLabel: true,
          label: "Date Created",
          list: ALL_ROLES,
          form: [],
          board: ALL_ROLES,
        },
        {
          name: "visibleAt",
          type: "datePicker",
          hideLabel: true,
          label: "Visible For Others At",
          list: [],
          formCreate: [manager, admin, operator, director, gym_manager],
          formEdit: [manager, admin, operator, director, gym_manager],
          board: [],
        },
      ],
    },
  ],
};

export default config;
